import React, { useState } from "react";
import "./ShareButton.scss";
import { motion } from "framer-motion";
import { isMobile } from "react-device-detect";
import copy from "copy-to-clipboard";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import { window, exists } from "browser-monads";
import Popover, { ArrowContainer } from "react-tiny-popover";

const ShareButton = React.memo(
    ({ children, componentClass, globalTexts, shareUrl }) => {
        exists(window);
        const handleOnClick = () => {
            if (navigator.share) {
                navigator
                    .share({
                        title: globalTexts.shareMessageTitle,
                        text: globalTexts.shareMessageText,
                        url: shareUrl || window.location.href,
                    })
                    .then(() => {
                        console.log("Successfully shared");
                    })
                    .catch((error) => {
                        console.error(
                            "Something went wrong sharing your message",
                            error
                        );
                        window.location.reload(true);
                    });
            }
        };

        const animateShareList = {
            initial: {
                opacity: 0,
                transition: {
                    when: "afterChildren",
                    staggerChildren: 0.05,
                },
            },

            enter: {
                opacity: 1,
                transition: {
                    when: "beforeChildren",
                    staggerChildren: 0.05,
                },
            },
        };

        const animateShareItems = {
            initial: {
                y: 20,
                opacity: 0,
            },

            enter: {
                y: 0,
                opacity: 1,
                transition: {
                    type: "spring",
                    ease: "easeIn",
                },
            },
        };

        const dummySites = ["Facebook", "Twitter", "Copy"];
        const [isCopied, setIsCopied] = useState(false);

        const [isPopoverOpen, setIsPopoverOpen] = useState(false);

        const handleCopy = () => {
            copy(shareUrl || window.location.href);
            setIsCopied(true);
        };

        return (
            <>
                {isMobile ? (
                    <button
                        onClick={handleOnClick}
                        type="button"
                        className={`share-button ${
                            componentClass ? componentClass : ""
                        }`}
                    >
                        {children}
                    </button>
                ) : (
                    <Popover
                        containerClassName="popover"
                        isOpen={isPopoverOpen}
                        align="center"
                        padding={20}
                        position={"top"} // preferred position
                        containerStyle={{
                            backgroundColor: "#fff",
                            overflow: "visible",
                            maxWidth: "16rem",
                        }}
                        content={({ position, targetRect, popoverRect }) => (
                            <ArrowContainer
                                position={position}
                                targetRect={targetRect}
                                popoverRect={popoverRect}
                                arrowColor={"white"}
                                arrowSize={10}
                                arrowStyle={{
                                    opacity: 1,
                                    bottom: "-1rem",
                                }}
                            >
                                <motion.ul
                                    className="popover__list"
                                    initial="initial"
                                    animate="enter"
                                    variants={animateShareList}
                                >
                                    {dummySites.map((item, key) => (
                                        <motion.li
                                            className="popover__item"
                                            key={key}
                                            variants={animateShareItems}
                                        >
                                            {item === "Facebook" && (
                                                <FacebookShareButton
                                                    url={
                                                        shareUrl ||
                                                        window.location.href
                                                    }
                                                    children={
                                                        <span>{item}</span>
                                                    }
                                                />
                                            )}
                                            {item === "Twitter" && (
                                                <TwitterShareButton
                                                    url={
                                                        shareUrl ||
                                                        window.location.href
                                                    }
                                                    children={
                                                        <span>{item}</span>
                                                    }
                                                />
                                            )}
                                            {item === "Copy" && (
                                                <>
                                                    <button
                                                        onClick={handleCopy}
                                                        className="copy-button"
                                                    >
                                                        <span>
                                                            {isCopied
                                                                ? globalTexts.copiedLinkLabel
                                                                : globalTexts.copyLinkLabel}
                                                        </span>
                                                    </button>
                                                </>
                                            )}
                                        </motion.li>
                                    ))}
                                </motion.ul>
                            </ArrowContainer>
                        )}
                        onClickOutside={() => setIsPopoverOpen(!isPopoverOpen)}
                        transitionDuration=".5"
                    >
                        <button
                            onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                            className={`share-button ${componentClass}`}
                        >
                            {children}
                        </button>
                    </Popover>
                )}
            </>
        );
    }
);

export default ShareButton;
